export default "__VITE_ASSET__DqMFVkyk__"